export const CDIRAModalStyles = {
  modalStyle: {
    padding: '30px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '480px',
    width: '100%',
    borderRadius: '12px',
    background: '#FFF',
    boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.12)',
    '@media(max-width:600px)': {
      maxWidth: '351px',
      width: '100%',
    },
    '@media(max-width:420px)': {
      maxWidth: '300px',
    },
    '@media(max-width:360px)': {
      maxWidth: '250px',
    },
  },
  heading: {
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Arial',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    marginTop: '12px',
  },
  subHeading: {
    color: '#000',
    fontFamily: 'Arial',
    textAlign: 'center',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
  },
  contentStyles: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '16px',
  },
  buttonStyles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    marginTop: '24px',
    '@media(max-width:600px)': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  button1Style: {
    borderRadius: '56px',
    padding: '12px 20px',
    border: '1.6px solid  #661C69',
    color: '#661C69',
    textAlign: 'center',
    fontFamily: 'Arial',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '16px',
    '@media(max-width:600px)': {
      width: '100%',
      maxWidth: '291px',
    },
  },
  button2Style: {
    borderRadius: '56px',
    background: '#661C69',
    padding: '12px 54px',
    color: '#FFF',
    textAlign: 'center',
    fontFamily: 'Arial',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '16px',
    '@media(max-width:600px)': {
      width: '100%',
      maxWidth: '291px',
    },
  },
};
